import type { ComponentType } from 'react';
import { createContext } from 'react';

export interface ModalContext {
  component: ComponentType<any> | null
  componentProps: any
  hideModal: () => void
  dismissModal: () => void
  showModal: <Props = any>(
    component: ComponentType | ((props: Props) => JSX.Element),
    componentProps: Props
  ) => Promise<any>
}

export const ModalContext = createContext<ModalContext>({
  component: null,
  componentProps: {},
  hideModal: () => {
    console.warn('hideModal method not implemented')
  },
  dismissModal: () => {
    console.warn('dismissModal method not implemented')
  },
  showModal: () => {
    console.warn('showModal method not implemented')
    return Promise.resolve()
  },
})

export const ModalContextProvider = ModalContext.Provider
export const ModalContextConsumer = ModalContext.Consumer
